import { render } from "./PreencherRecolha.vue?vue&type=template&id=3e804a94"
import script from "./PreencherRecolha.vue?vue&type=script&lang=js"
export * from "./PreencherRecolha.vue?vue&type=script&lang=js"
script.render = render

export default script